import React from 'react';
import styled from 'styled-components';
import HeroBkg from '../Resources/HeroBkg.jpg';
import Logo from '../Resources/Logo1.png';
import { useInView } from "react-intersection-observer";

const HeroContainer = styled.div`
    margin-top: 45px;
    position: relative;
    display: Flex;
    justify-content: center;
    height: calc(80vh - 60px);
    max-height: 850px;
    background: lightgrey;
    width: 100%;
    padding: 0;
    background-image: url(${HeroBkg});
    background-size: cover;
    background-position: ${props => props.$mobile ? "bottom" : "center"};
`
const InnerContainer = styled.div`
    position: relative;
    width: 100%;
    max-width: 1500px;
`
const HeroLogo = styled.div`
    position: absolute;
    left: 5vw;
    top: 2vh;
    display flex;
    width: ${props => props.$mobile ? "45vw" : "18vw"};
    height: ${props => props.$mobile ? "45vw" : "18vw"};
    min-height: ${props => props.$mobile ? "200px" : "100px"};
    min-width: ${props => props.$mobile ? "200px" : "100px"};
    background-image: url(${Logo});
    background-position: center;
    background-size:cover;
    background-repeat: no-repeat;
    margin-top: 30px;
    filter: drop-shadow(0px 5px 20px rgb(255 255 255 / 1));
  `
const HeroTag = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    background: #ffffff99;
    border-radius: 25px;
    padding: 20px;
    left: ${props => props.$mobile ? "2.5%" : ""};
    right: ${props => props.$mobile ? "" : "50px"};
    bottom: ${props => props.$mobile ? "10px" : "50%"};
    width: ${props => props.$mobile ? "95%" : "40%"};
    max-height: ${props => props.$mobile ? "" : "200px"};
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;

    & h4{
        margin: 0;
        font-size: ${props => props.$mobile ? "1em" : "1.3em"};
        padding-bottom: 10px;
    }
`
const ContactCTA = styled.button`
    display: block;
    width: 90%;
    height: 20%;
    min-height: ${props => props.$mobile ? "40px" : "55px"};
    border-radius: 25px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
    background-color:#3F2064;
    border: 0 none;
    bottom: 10px;
    color: white;
    font-weight: bold;
    font-size: 1em;
    `
function Hero(props) {
    const { ref, inView, entry } = useInView();
    const contactScroll = () => {
        const element = document.getElementById('ContactContainer');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }
    return (
        <h1>
            <HeroContainer id='HomeContainer' $mobile={props.$mobile}>
                <InnerContainer>
                    <HeroLogo $mobile={props.$mobile} />
                    <HeroTag $mobile={props.$mobile}>
                        <h4>Your Expert Handyman for all your renovation and repair needs</h4>
                        <ContactCTA $mobile={props.$mobile}
                            onClick={contactScroll}>
                            Contact Us Now!
                        </ContactCTA>
                    </HeroTag>
                </InnerContainer>
            </HeroContainer>
        </h1>
    );
}

export default Hero;

